import Icon from '@components/Icon/Icon';

import styles from './Field.module.scss';

interface EmailFieldProps {
  email: string;
  label?: string;
  size?: 'regular' | 'small' | 'extra-small';
  /** Will default to true. If false, no UI changes upon interaction. */
  interactive?: boolean;
}

const EmailField: React.FC<React.PropsWithChildren<EmailFieldProps>> = ({
  email,
  label,
  size,
  interactive = true,
}) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      <div className={styles['card-item-icon-circle']} data-is-interactive={interactive} data-size={size}>
        <Icon type="email" className={styles['field-icon']} />
      </div>
      <div className={styles['field-data']}>
        <div className={styles['field-data-value']} data-type="email">
          {email}
        </div>
        {label && <div className={styles['field-data-label']}>{label}</div>}
      </div>
    </div>
  );
};

export default EmailField;
